import { NCZIReference } from './ncziTypes';

export type NCZIElectronicPrescriptionSignatureStatus =
  'JePodpisanyPlatny'
  | 'JePodpisanyNeplatny'
  | 'JePodpisanyNeovereny'
  | 'NieJePodpisany';

export const DOSAGE_TYPE_PEV = 'PEV';
export const DOSAGE_TYPE_VAR = 'VAR';

export interface NCZIElectronicPrescriptionItem {
  CiarovyKod: string;
  Datum2Vykazany: string;
  DatumCasEvidencie: string;
  DatumPoslednejModifikacie: string;
  Davkovanie: {
    TypDavkovania: NCZIReference;
    JednotkaDavkovania: NCZIReference | undefined;
    SposobPodania: NCZIReference | undefined;
    Periodicita: NCZIReference | undefined;
    Poznamka: string;
    PrepisDavkovania: string;
    DenneDavkovanie1: {
      DenneDavkovanie1: string[];
    } | undefined;
    DenneDavkovanie2: {
      PocetJednotiek: string;
      OpakovanieVHodinach: string;
    } | undefined;
  };
  UdajeProdukt: {
    ATCDoplnok: undefined;
    KodATCVykazany: undefined;
    KodProduktPZSVykaz: string;
    MnozstvoVykazane: number;
    MernaJednotka: string | undefined;
    ProduktPZSVykaz: {
      additionalName: string;
      antibioticsChemotherapy: boolean;
      code: string;
      name: string;
      opl: boolean;
      tailored: boolean;
      type: string;
    } | null;
  };
  PohlaviePoistenca: string;
  StatPoistenca: string;
  ExternyIdentifikatorRiadku: number;
  PredpisujuciLekar: {
    ICOHlavnaZlozka: number;
    IdHlavnaZlozka: number;
    IdNizsiaZlozkaPredpisujucehoLekara: number;
    KodNizsiaZlozkaPredpisujucehoLekara: string;
    KodPredpisujuciLekar: string;
  };
  OdporucajuciLekar: {
    KodOdporucajucaNZ: string;
    KodOdporucajuciLekar: string;
    DatumOdporucania: string;
  } | undefined;
  ZastupovanyLekar: {
    KodZastupovanaNZ: string;
    KodZastupovanyLekar: string;
  } | undefined;
  IdPoistenec: number;
  IdPreskripcnehoZaznamu: number;
  KodDiagnozaVykazana: string;
  DiagnozaVykazana: NCZIReference | null;
  NeodkladnaZS: boolean;
  Neplatic: boolean;
  NovorodenecNaRCRodica: boolean;
  PlatnostReceptu: string;
  ProduktNaVynimku: boolean;
  RodneCisloAkceptovane: number;
  RodneCisloVykazane: number;
  SignatureValidationStatus: NCZIElectronicPrescriptionSignatureStatus;
  TrvalePostihnutie: boolean;
  VynutenyZapis: boolean;
  ZakazVydaniaNahrady: boolean;
  Zdovodnenie: string | undefined;
  OpisPomockyNaMieru: string | undefined;
  DovodUhradyPacienta: string | undefined;
  PeriodaOpakovanehoReceptu: number | undefined;
  PocetOpakovaniOpakovanehoReceptu: number | undefined;
  AplikacnaZonaParovehoOrganu: string | undefined;
  insurance: string;
  UdajeIPL: {
    PokynKUzivaniuIPL: string;
    PokynyPriVyrobeIPL: string;
    ZlozenieIPL: string;
  } | undefined
}